import type { AddressBookTag } from '@integrations/address-books-tags/contracts/address-book-tag.contract';

import { inject } from '@angular/core';
import type { CreateQueryOptions } from '@tanstack/angular-query-experimental';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';

import { retryTransient } from '@integrations/shared/retry-policy';

import { AddressBooksTagsApiService } from '../api/address-books-tags-api.service';

export const ADDRESS_BOOKS_TAGS_QUERY_KEY = ['address-books-tags'] as const;

type AddressBooksTagsQueryOverrides = Partial<Omit<CreateQueryOptions<AddressBookTag[]>, 'queryKey' | 'queryFn'>>;

export function injectAddressBooksTagsQuery(optionsFn?: () => AddressBooksTagsQueryOverrides) {
    const api = inject(AddressBooksTagsApiService);

    return injectQuery(() => ({
        staleTime: 5 * 60 * 1000, // 5 minutes
        // A definitive 4xx is how "the account does not have this" is detected, so it must
        // not be retried; a transient failure gets a few attempts instead of being mistaken
        // for that answer (#71534).
        retry: retryTransient,
        queryKey: ADDRESS_BOOKS_TAGS_QUERY_KEY,
        queryFn: () => lastValueFrom(api.getTags()),
        ...optionsFn?.(),
    }));
}
